<template>
  <div class="date-panel">
    <date-panel
      ref="datePanel"
      @pick="pick"
      :picker-options="pickerOptions"
    ></date-panel>
  </div>
</template>
<script>
import DatePanel from "element-ui/packages/date-picker/src/panel/date.vue";
import { dateFormat } from "@/utils";

export default {
  props: {
    date: {
      default: new Date(new Date()),
      type: [Date, String]
    },
    showTime: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  components: {
    DatePanel
  },
  model: {
    prop: "date",
    event: "change"
  },
  mounted() {
    this.$refs.datePanel.value = new Date(this.date);
    this.$refs.datePanel.showTime = this.showTime;
    this.$refs.datePanel.visible = true;
  },
  methods: {
    pick(date) {
      this.$refs.datePanel.value = date;
      this.$refs.datePanel.resetView && this.$refs.datePanel.resetView();
      this.$emit("change", dateFormat(date, "yyyy-MM-dd"));
    }
  }
};
</script>
<style scoped>
.date-panel {
  width: 330px;
  height: 350px;
}
.date-panel >>> .el-picker-panel__footer {
  display: none !important;
}
.date-panel >>> .el-picker-panel {
  box-shadow: none;
  border: 0;
}
</style>
